import React from 'react';

/**
 * Persistent host alert (e.g. reboot required). Shown on the workspace and
 * merged into ActivityBanner while long-running jobs are in progress.
 */
export default function HostAlertBanner({ title, detail }) {
  if (!title) return null;

  return (
    <div
      className="shrink-0 bg-red-950 border-b border-red-500/60 px-6 py-3"
      role="alert"
      aria-live="assertive"
    >
      <div className="flex items-start gap-3 max-w-5xl mx-auto">
        <svg
          className="h-5 w-5 text-red-400 shrink-0 mt-0.5"
          fill="currentColor"
          viewBox="0 0 20 20"
          aria-hidden="true"
        >
          <path
            fillRule="evenodd"
            d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
            clipRule="evenodd"
          />
        </svg>
        <div className="min-w-0">
          <p className="text-sm font-semibold tracking-wide text-red-200 uppercase">{title}</p>
          {detail && (
            <p className="text-xs text-red-100/90 mt-1 leading-relaxed">{detail}</p>
          )}
        </div>
      </div>
    </div>
  );
}
